//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { datetimeFormat } from '@/plugin/format.js'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import moment from 'moment'
export default {
  data () {
    return {
      usersdata: [],
      filters: {
        keyword: '',
        fromTime: null,
        toTime: null
      },
      pickerOptionsS: {
        disabledDate: time => {
          if (this.filters.toTime !== null) {
            return time.getTime() > Date.now() || time.getTime() > this.value2
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      pickerOptionsE: {
        disabledDate: time => {
          return (
            time.getTime() < this.filters.fromTime ||
            time.getTime() > Date.now()
          )
        }
      },
      selections: [],
      lockList: [],
      unLockList: []
    }
  },
  methods: {
    getlist: function () {
      let params = {
        UserName: this.filters.keyword.trim(),
        RegistFrom: moment(this.filters.fromTime)
          .utcOffset(480)
          .format('YYYY-MM-DD HH:mm:ss'),
        RegistTo: moment(this.filters.toTime)
          .utcOffset(480)
          .format('YYYY-MM-DD HH:mm:ss')
      }
      this.$api
        .getUser(params)
        .then(res => {
          if (res.Status === 1) {
            this.usersdata = res.Entity
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function (res) {
          this.$alert('获取保修信息错误！', '错误', {
            confirmButtonText: '确定'
          })
        })
    },
    exportExcel () {
      /* generate workbook object from table */
      var wb = XLSX.utils.table_to_book(document.querySelector('#table-data'))
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      })
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: 'application/octet-stream' }),
          '保修注册用户' + new Date().getMilliseconds() + '.xlsx'
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout)
      }
      return wbout
    },
    handleLock: function () {
      this.$confirm(
        '锁定' + this.lockList.length.toString() + '个用户吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        var params = []
        this.lockList.forEach(item => {
          params.push(item.Id)
        })
        this.$api.lockUser(params).then(res => {
          if (res.Status === 1) {
            this.$message({
              message: '用户锁定成功',
              type: 'success'
            })
            this.getlist()
          } else {
            this.$alert(res.Message.replace(/\n\r/g, '</br>'), '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    handleUnLock: function () {
      this.$confirm(
        '激活' + this.unLockList.length.toString() + '个用户吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        var params = []
        this.unLockList.forEach(item => {
          params.push(item.Id)
        })
        this.$api.unLockUser(params).then(res => {
          if (res.Status === 1) {
            this.$message({
              message: '用户激活成功',
              type: 'success'
            })
            this.getlist()
          } else {
            this.$alert(res.Message.replace(/\n\r/g, '</br>'), '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    handleDelete: function () {
      this.$confirm(
        '删除' + this.selections.length.toString() + '个用户吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        var params = []
        this.selections.forEach(item => {
          params.push(item.Id)
        })
        this.$api.deleteUser(params).then(res => {
          if (res.Status === 1) {
            this.$message({
              message: '用户删除成功',
              type: 'success'
            })
            this.getlist()
          } else {
            this.$alert(res.Message.replace(/\n\r/g, '</br>'), '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    datetimeFormat: function (row, column) {
      let time = datetimeFormat(row, column)
      return time
    },
    selectionChange: function (selections) {
      this.selections = selections
      this.lockList = []
      this.unLockList = []
      selections.forEach(item => {
        if (item.Status === 0) {
          this.lockList.push(item)
        } else {
          this.unLockList.push(item)
        }
      })
    },

    formatState: function (row, column) {
      if (row.Status === 1) {
        return '已停用'
      } else {
        return '使用中'
      }
    }
  },
  mounted () {
    this.getlist()
  }
}



// WEBPACK FOOTER //
// ./src/admin/User.vue